import React, { Component } from 'react'
import { Document, Page, View, Text, Image } from '@react-pdf/renderer'

type KioskQrCodePrintProps = {
  name: string
  content: string
}

export default class KioskQrCodePrint extends Component<KioskQrCodePrintProps> {
  render() {
    const { name, content } = this.props

    return (
      <Document>
        <Page size="A4">
          <View>
            <Text style={{marginTop: 30, marginLeft: 30}}>{name}</Text>

            <Image source={content} style={{ width: 200, marginTop: 30, marginLeft: 30 }} />
          </View>
        </Page>
      </Document>
    )
  }
}
